import { openDB } from 'idb';

const DB_NAME = 'qapp-firebase-messages';
const DB_VERSION = 1;
const STORE_NAME = 'messages';

export function useIndexedDB() {
  async function createOrGetIndexedDB() {
    const db = await openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          const store = db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
        }
      },
    });
    return db;
  }

  return { createOrGetIndexedDB };
}